import AbstractCRMApi from '../../AbstractCRMApi';

class CurrencyApi extends AbstractCRMApi {
    protected endpoint: string = 'currency';

    async getRate(fromCurrency: string, toCurrency: string): Promise<number> {
        return (await this.get(`/rate/${fromCurrency}/${toCurrency}`)).data;
    }
}

export default new CurrencyApi();
